import { useCallback, useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useToast } from '../shared/ui';
import './admin.css';
import { api, sessionName, setSessionName } from './api';
import { Layout } from './components/Layout';
import { AuditPage } from './pages/Audit';
import { Login } from './pages/Login';
import { Overview } from './pages/Overview';
import { TenantDetailPage } from './pages/TenantDetail';
import { TenantsPage } from './pages/Tenants';

/** Panel de administración de ECINSA: admin.provalia.ecinsapp.es */
export function AdminApp(): JSX.Element {
  const toast = useToast();
  const [authed, setAuthed] = useState<boolean>(() => api.token() !== null);
  const [name, setName] = useState<string | null>(() => sessionName());

  useEffect(() => {
    api.onUnauthorized(() => {
      setSessionName(null);
      setAuthed(false);
      toast('La sesión ha caducado. Vuelve a entrar.', 'bad');
    });
  }, [toast]);

  const logout = useCallback(() => {
    api.clear();
    setSessionName(null);
    setAuthed(false);
    toast('Sesión cerrada');
  }, [toast]);

  if (!authed) {
    return (
      <Login
        onLoggedIn={(n) => {
          setName(n);
          setAuthed(true);
        }}
      />
    );
  }

  return (
    <Layout userName={name} onLogout={logout}>
      <Routes>
        <Route path="/" element={<Overview />} />
        <Route path="/clientes" element={<TenantsPage />} />
        <Route path="/clientes/:slug" element={<TenantDetailPage />} />
        <Route path="/registro" element={<AuditPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
